import { STATUSES } from 'constants/constants';

export const retryShipmentsCSVColumns = [
  {
    label: 'Referencia',
    value: 'reference',
  },
  {
    label: 'Almacén',
    value: 'warehouse.warehouse',
  },
  {
    label: 'Agencia',
    value: 'agency.agency_name',
  },
  {
    label: 'Creación',
    value: (row) => new Date(row.creation_date).toLocaleString(['es-ES']),
  },
  {
    label: 'Error',
    value: 'error',
  },
  {
    label: 'Estado',
    value: (row) => STATUSES[row.status].text,
  },
];
